import { PaneDefinition, definePane, OpenPane } from "../definePane";

export interface DocumentReviewPaneDefinition<TProps> extends PaneDefinition<TProps> {
    /** The document the review is working on, so the document on the stage knows the review is about what it is showing. */
    reviewedDocumentId: (props: TProps) => string | undefined;
}

/**
 * A right pane that works on one document. The document pane closes it when the user pages to another
 * document, and its toolbar button toggles it instead of opening a second one.
 */
export function defineDocumentReviewPane<TProps>(definition: DocumentReviewPaneDefinition<TProps>): PaneDefinition<TProps> {
    return definePane(definition);
}

export function getReviewedDocumentId(pane: OpenPane | undefined): string | undefined {
    if (pane === undefined || !("reviewedDocumentId" in pane.definition)) {
        return undefined;
    }
    return (pane.definition as DocumentReviewPaneDefinition<never>).reviewedDocumentId(pane.props as never);
}
